import React from "react";
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import CodeIcon from '@mui/icons-material/Code';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import DashboardIcon from '@mui/icons-material/Dashboard';
import HubIcon from '@mui/icons-material/Hub';
import TimelineIcon from '@mui/icons-material/Timeline';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { useLanguage } from '../i18n/LanguageProvider';
import logo from '../assets/images/bikmin (1).png';
import '../assets/styles/Main.scss';

function Main() {
  const { t } = useLanguage();
  const highlights = t('about.highlights') as { label: string; value: string }[];
  const paragraphs = t('about.paragraphs') as string[];
  const services = t('about.services') as string[];
  const company = t('about.company') as string;

  const scrollToSection = (section: string) => {
    const element = document.getElementById(section);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="hero" id="hero">
      <div className="container">
        <div className="about-section">
          <div className="content">
            <div className="eyebrow">{t('hero.greeting')}</div>
            <h1>{t('hero.name')}</h1>
            <p className="role">{t('hero.title')}</p>
            <p className="tagline">{t('hero.tagline')}</p>
            <div className="badges">
              {(t('hero.badges') as string[]).map((badge) => (
                <span key={badge} className="badge">{badge}</span>
              ))}
            </div>
            <div className="cta-group">
              <Button variant="contained" color="primary" onClick={() => scrollToSection('projects')}>
                {t('hero.actions.primary')}
              </Button>
              <Button variant="outlined" color="inherit" onClick={() => scrollToSection('contact')}>
                {t('hero.actions.secondary')}
              </Button>
            </div>
            <div className="highlights">
              {highlights.map((item) => (
                <div className="highlight" key={item.label}>
                  <span className="highlight-label">{item.label}</span>
                  <span className="highlight-value">{item.value}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="image-wrapper">
            <img src={logo} alt="Bikmin Logo" />
          </div>
        </div>
      </div>

      <div className="about-blurb" id="about">
        <div className="about-header">
          <div className="about-brand">
            <img src={logo} alt="Bikmin Logo" />
            <div>
              <p className="about-eyebrow">{t('about.title')}</p>
              <h2>{company}</h2>
            </div>
          </div>
        </div>
        <div className="about-grid">
          <div className="about-copy">
            <div className="about-text">
              {paragraphs.map((text, index) => (
                <p key={index}>{text}</p>
              ))}
            </div>
            <div className="highlights">
              {highlights.map((item) => (
                <div className="highlight" key={item.label}>
                  <span className="highlight-label">{item.label}</span>
                  <span className="highlight-value">{item.value}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="about-services">
            <div className="services-header">
              <p className="about-eyebrow">{t('about.servicesTitle')}</p>
              <h3>{t('about.company')}</h3>
            </div>
            <Grid container spacing={2}>
              {services.map((service, index) => {
                const icons = [CodeIcon, PhoneIphoneIcon, DashboardIcon, HubIcon, TimelineIcon, AutoAwesomeIcon];
                const Icon = icons[index % icons.length];
                return (
                  <Grid item xs={12} sm={6} key={service}>
                    <div className="service-card">
                      <div className="service-icon"><Icon /></div>
                      <p>{service}</p>
                    </div>
                  </Grid>
                );
              })}
            </Grid>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;